import { createContext, useContext } from 'react';
import { WebConfig } from '../@types/pay';

export const ConfigContext = createContext<WebConfig | null>(null);

export function useWebConfig() {
  return useContext(ConfigContext);
}
